import React from 'react';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { TitleList } from 'store/ducks/globalTypes';
import TitleBar from 'components/TitleBar';
import article8Areas from 'constants/article8Areas';
import CardComponent from 'components/CardComponent';
import * as Styled from '../Layout.styled';
import { useTranslation } from 'react-i18next';

const { useToken } = theme;

const MainInventories: React.FC = () => {
  const { token } = useToken();
  const { scheme } = useSelector((state: RootState) => state.global);
  const areas = article8Areas();
  const { t } = useTranslation();

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar title={t(TitleList.ARTICLE8)} />
      <Styled.HorizontalLayoutMain theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {areas.map((item: any, index: number) => (
              <div key={item.area} style={{ position: 'relative' }}>
                <CardComponent
                  area={item.title}
                  infoText={item.infoText}
                  href={item.href}
                  textOnTop=""
                  minHeight="100px"
                />
              </div>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayoutMain>
    </Styled.StyledLayout>
  );
};

export default MainInventories;
